import React from 'react';
import { Modal, ModalHeader, ModalBody } from 'reactstrap';
import NeoBadge from '../../../../../components/Common/NeoBadge';
import { TASK_STATUS_LABELS } from '../../../../../constants/tasks';

const formatTimeAgo = (timestamp) => {
    if (!timestamp) return '';
    try {
        const date = timestamp.toDate ? timestamp.toDate() : new Date(timestamp);
        return new Intl.DateTimeFormat('pt-BR', { 
            day: '2-digit', 
            month: 'short', 
            hour: '2-digit', 
            minute: '2-digit' 
        }).format(date);
    } catch {
        return '';
    }
};

const SidebarHistoryModal = ({ isOpen, toggle, statusHistory }) => {
    return (
        <Modal isOpen={isOpen} toggle={toggle} centered>
            <ModalHeader toggle={toggle} className="border-bottom-0">
                <div className="d-flex align-items-center fw-bold text-brand-primary font-size-15 neo-font-outfit">
                    <i className="mdi mdi-history me-2 text-accent font-size-18"></i>
                    Histórico de Alterações do Card
                </div>
            </ModalHeader>
            <ModalBody className="p-4 custom-scrollbar overflow-auto" style={{ maxHeight: '60vh' }}>
                {(!statusHistory || statusHistory.length === 0) ? (
                    <div className="text-center py-4 rounded-3 border bg-light">
                        <i className="mdi mdi-text-box-search-outline text-muted font-size-32"></i>
                        <p className="mt-2 mb-0 text-brand-secondary fw-semibold font-size-13">
                            Nenhuma movimentação foi registrada ainda.<br/>
                            Cartões recém-criados ou muito antigos podem não possuir histórico salvo.
                        </p>
                    </div>
                ) : (
                    <ul className="list-unstyled mb-0 border-start ps-3 ms-2">
                        {statusHistory.map((historyItem, idx) => (
                            <li key={idx} className="mb-4 position-relative">
                                <p className="mb-1 d-flex align-items-center gap-1 font-size-13 fw-bold text-brand-primary">
                                    Movido para a coluna{' '}
                                    <NeoBadge color="info">
                                        {TASK_STATUS_LABELS[historyItem.to] || historyItem.to}
                                    </NeoBadge>
                                </p>
                                <p className="mb-0 d-flex align-items-center text-muted font-size-11 fw-semibold">
                                    <i className="mdi mdi-account-circle-outline me-1"></i>
                                    {historyItem.user?.name || 'Sistema'}
                                    <span className="mx-2">•</span>
                                    <i className="mdi mdi-clock-outline me-1"></i>
                                    {formatTimeAgo(historyItem.date)}
                                </p>
                            </li>
                        ))}
                    </ul>
                )}
            </ModalBody>
        </Modal>
    );
};

export default SidebarHistoryModal;
